export const matomoSites = [
	{ id: 1, code: 'JBTC2020' },
	{ id: 2, code: 'JBTC2021' },
	{ id: 3, code: 'JBTC2022' },
	{ id: 4, code: 'AHT2022' },
]
